import { BadgeCheck } from "lucide-react";

const CH = {
  airbnb: { bg: "#FFECEF", fg: "#E4484D" },
  vrbo: { bg: "#E8F0FC", fg: "#0F52BA" },
  google: { bg: "#EAF1FE", fg: "#4285F4" },
  "booking.com": { bg: "#E6EEF7", fg: "#003580" },
  bookingcom: { bg: "#E6EEF7", fg: "#003580" },
  ownerrez: { bg: "#F4EFE9", fg: "#8B7A6E" },
};

export const ChannelBadge = ({ source }) => {
  const c = CH[(source || "").toLowerCase()] || { bg: "#F4EFE9", fg: "#8B7A6E" };
  return (
    <span data-testid={`channel-${source}`} style={{ background: c.bg, color: c.fg }}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-bold">
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: c.fg }} />
      {source}
    </span>
  );
};

export const VerifiedBadge = () => (
  <span data-testid="verified-badge" className="inline-flex items-center gap-1 text-[11px] font-semibold text-camel">
    <BadgeCheck size={13} strokeWidth={2} /> Verified via OwnerRez
  </span>
);
